const umlauteRestore = [
  { code: "&Uuml;", word: "Ü" },
  { code: "&Auml;", code: "Ä" },
  { code: "&Ouml;", word: "Ö" },
  { code: "&auml;", word: "ä" },
  { code: "&Uuml;", word: "ü" },
  { code: "&ouml;", word: "ö" },
  { code: "&Szlig;", word: "ß" },
];

export function restoreUmlaute(str) {
  for (let i = 0; i < umlauteRestore.length; i++) {
    str.replace(umlauteRestore[i].word, umlauteRestore[i].code);
  }
  return str;
}

const umlautMap = {
  "\u00dc": "UE",
  "\u00c4": "AE",
  "\u00d6": "OE",
  "\u00fc": "ue",
  "\u00e4": "ae",
  "\u00f6": "oe",
  "\u00df": "ss",
};

export function replaceUmlaute(str) {
  return str
    .replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, (a) => {
      const big = umlautMap[a.slice(0, 1)];
      return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
    })
    .replace(
      new RegExp("[" + Object.keys(umlautMap).join("|") + "]", "g"),
      (a) => umlautMap[a]
    );
}
